import React from 'react'
import PropTypes from 'prop-types'
import { FormInput, Margin, Text } from 'shared/components'
import { EditableFormPanel } from 'routes/shared/components'

import * as styles from './styles'

const AddMemberBankAccountFormComponent = ({
  form,
  header,
  onSubmitRequest,
}) => (
  <EditableFormPanel header={header} form={form} onSubmit={onSubmitRequest}>
    {(editable) => {
      const disabled = !editable

      return (
        <>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={16}>
              Name
            </Text>
            <FormInput
              strictLong
              name="displayName"
              placeholder="Display name"
              css={styles.control}
              disabled={disabled}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={16}>
              Account Number
            </Text>
            <FormInput
              strictLong
              name="accountNumber"
              placeholder="Account Number"
              css={styles.control}
              disabled={disabled}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={16}>
              Bank name
            </Text>
            <FormInput
              strictLong
              name="bankName"
              placeholder="Bank name"
              css={styles.control}
              disabled={disabled}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={16}>
              Currency
            </Text>
            <FormInput
              strictLong
              name="currency"
              placeholder="Currency"
              css={styles.control}
              disabled={disabled}
            />
          </Margin>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={16}>
              Iban
            </Text>
            <FormInput
              strictLong
              name="iban"
              placeholder="Iban"
              css={styles.control}
              disabled={disabled}
            />
          </Margin>
        </>
      )
    }}
  </EditableFormPanel>
)

AddMemberBankAccountFormComponent.propTypes = {
  form: PropTypes.shape(),
  header: PropTypes.string.isRequired,
  onSubmitRequest: PropTypes.func,
}

export default AddMemberBankAccountFormComponent
